import React from 'react';
import { HeadingContainer, HeadingText, Logo } from './authenticationStepHeading.style';
import AuthenticateLogo from '../../../../images/logos/authenticate_rgb.svg';
import PropTypes from 'prop-types';

const AuthenticationStepHeading = ({ text }) => {
    return (
        <HeadingContainer>
            <HeadingText>{text}</HeadingText>
            <Logo src={AuthenticateLogo} alt="Authenticate Logo" />
        </HeadingContainer>
    );
};

AuthenticationStepHeading.propTypes = {
    text: PropTypes.string,
};

export default AuthenticationStepHeading;
